import React from "react";
import { Controller, useFieldArray } from "react-hook-form";
import {
  Form,
  Collapse,
  Select,
  Input,
  Space,
  Button,
  InputNumber,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { formItemLayout } from "../../../utils/UI";

const { Panel } = Collapse;
const { Option } = Select;

const FileNameProcessingElement = (props) => {
  const { errors, control, watch } = props;
  const {
    fields: processingRulesFields,
    append: processingRulesAppend,
    remove: processingRulesRemove,
  } = useFieldArray({
    control,
    name: "job.fileNameProcessing.processingRules",
  });

  const appendType = (index) => {
    switch (
      watch(`job.fileNameProcessing.processingRules.${index}.appendType`)
    ) {
      case "Text":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="Append Text"
              help={
                errors.job?.fileNameProcessing?.processingRules?.[index]
                  ?.appendText?.message
              }
              required
              validateStatus={
                errors.job?.fileNameProcessing?.processingRules?.[index]
                  ?.appendText
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name={`job.fileNameProcessing.processingRules.${index}.appendText`}
                render={({ field }) => (
                  <Input
                    {...field}
                    style={{ width: "180%" }}
                    placeholder="Enter Append Text"
                  />
                )}
              />
            </Form.Item>
          </>
        );
      case "BusinessDate":
      case "RunDate":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="Append Date Format"
              help={
                errors.job?.fileNameProcessing?.processingRules?.[index]
                  ?.appendDateFormat?.message
              }
              required
              validateStatus={
                errors.job?.fileNameProcessing?.processingRules?.[index]
                  ?.appendDateFormat
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name={`job.fileNameProcessing.processingRules.${index}.appendDateFormat`}
                render={({ field }) => (
                  <Select
                    {...field}
                    style={{ width: "180%" }}
                    label="Append Date Format "
                    showSearch
                    optionFilterProp="children"
                    placeholder="Select Append Date Format"
                  >
                    <Option value="yyyyMMdd">yyyyMMdd</Option>
                    <Option value="yyyy-MM-dd">yyyy-MM-dd</Option>
                    <Option value="dd-MM-yyyy">dd-MM-yyyy</Option>
                    <Option value="MM-dd-yyyy">MM-dd-yyyy</Option>
                    <Option value="yyyy.MM.dd">yyyy.MM.dd</Option>
                  </Select>
                )}
              />
            </Form.Item>
          </>
        );
      case "AppendAtStart":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="Append Type"
              help={
                errors.job?.fileNameProcessing?.processingRules?.[index]
                  ?.appendType?.message
              }
              required
              validateStatus={
                errors.job?.fileNameProcessing?.processingRules?.[index]
                  ?.appendType
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name={`job.fileNameProcessing.processingRules.${index}.appendType`}
                render={({ field }) => (
                  <Select
                    style={{ width: "180%" }}
                    {...field}
                    showSearch
                    placeholder="Select Append Type"
                  >
                    <Option value="Text">Text</Option>
                    <Option value="UniqueId">Unique Id</Option>
                    <Option value="BusinessDate">Business Date</Option>
                    <Option value="RunDate">Run Date</Option>
                  </Select>
                )}
              />
            </Form.Item>
          </>
        );

      default:
        return <></>;
    }
  };
  const processingRuleType = (index) => {
    switch (watch(`job.fileNameProcessing.processingRules.${index}.ruleType`)) {
      case "Trim":
      case "TrimStart":
      case "TrimEnd":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="Trim Count"
              help={
                errors.job?.fileNameProcessing?.processingRules?.[index]
                  ?.trimCount?.message
              }
              required
              validateStatus={
                errors.job?.fileNameProcessing?.processingRules?.[index]
                  ?.trimCount
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name={`job.fileNameProcessing.processingRules.${index}.trimCount`}
                render={({ field }) => (
                  <InputNumber
                    style={{ width: "180%" }}
                    {...field}
                    label="Trim Count"
                    defaultValue={0}
                    placeholder="Enter Trim Count value "
                  />
                )}
              />
            </Form.Item>
          </>
        );
      case "FindAndReplace":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="Replace Text"
              help={
                errors.job?.fileNameProcessing?.processingRules?.[index]
                  ?.replaceText?.message
              }
              required
              validateStatus={
                errors.job?.fileNameProcessing?.processingRules?.[index]
                  ?.replaceText
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name={`job.fileNameProcessing.processingRules.${index}.replaceText`}
                render={({ field }) => (
                  <Input
                    {...field}
                    style={{ width: "180%" }}
                    placeholder="Enter Replace Text"
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Replace With Text"
              help={
                errors.job?.fileNameProcessing?.processingRules?.[index]
                  ?.replaceWithText?.message
              }
              required
              validateStatus={
                errors.job?.fileNameProcessing?.processingRules?.[index]
                  ?.replaceWithText
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name={`job.fileNameProcessing.processingRules.${index}.replaceWithText`}
                render={({ field }) => (
                  <Input
                    style={{ width: "180%" }}
                    {...field}
                    placeholder="Enter Replace With Text Value"
                  />
                )}
              />
            </Form.Item>
          </>
        );
      case "AppendAtStart":
      case "AppendAtEnd":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="Append Type"
              help={
                errors.job?.fileNameProcessing?.processingRules?.[index]
                  ?.appendType?.message
              }
              required
              validateStatus={
                errors.job?.fileNameProcessing?.processingRules?.[index]
                  ?.appendType
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name={`job.fileNameProcessing.processingRules.${index}.appendType`}
                render={({ field }) => (
                  <Select
                    style={{ width: "180%" }}
                    {...field}
                    showSearch
                    placeholder="Select Append Type"
                  >
                    <Option value="Text">Text</Option>
                    <Option value="UniqueId">Unique Id</Option>
                    <Option value="BusinessDate">Business Date</Option>
                    <Option value="RunDate">Run Date</Option>
                  </Select>
                )}
              />
            </Form.Item>
            {appendType(index)}
            <Form.Item {...formItemLayout} label="Append Prefix">
              <Controller
                control={control}
                name={`job.fileNameProcessing.processingRules.${index}.appendPrefix`}
                render={({ field }) => (
                  <Input
                    style={{ width: "180%" }}
                    {...field}
                    placeholder="Enter Append Prefix"
                  />
                )}
              />
            </Form.Item>
            <Form.Item {...formItemLayout} label="Append Suffix">
              <Controller
                control={control}
                name={`job.fileNameProcessing.processingRules.${index}.appendSuffix`}
                render={({ field }) => (
                  <Input
                    style={{ width: "180%" }}
                    {...field}
                    placeholder="Enter Append Suffix"
                  />
                )}
              />
            </Form.Item>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <div className="container_ab">
        <Collapse defaultActiveKey={["7"]} expandIconPosition="end">
          <Panel header="File Name Processing Configuration " key="7">
            <Form.Item {...formItemLayout} label="Filter By Regex">
              <Controller
                control={control}
                name="job.fileNameProcessing.filterByRegex"
                render={({ field }) => (
                  <Input
                    {...field}
                    placeholder="Enter Filter By Regex Expression"
                  />
                )}
              />
            </Form.Item>
            <Form.Item {...formItemLayout} label="Filter By File Extensions">
              <Controller
                control={control}
                name="job.fileNameProcessing.filterByFileExtensions"
                render={({ field }) => (
                  <Select
                    {...field}
                    mode="tags"
                    placeholder="Filter By File Extensions"
                  />
                )}
              />
            </Form.Item>
            <Form.Item {...formItemLayout} label="Processing Rules">
              {processingRulesFields?.map((item, index) => {
                return (
                  <>
                    <div>
                      <Space
                        key={item.id}
                        style={{
                          display: "Block",
                          marginBottom: 8,
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          {...formItemLayout}
                          label="Rule Type"
                          help={
                            errors.job?.fileNameProcessing?.processingRules?.[
                              index
                            ]?.ruleType?.message
                          }
                          required
                          validateStatus={
                            errors.job?.fileNameProcessing?.processingRules?.[
                              index
                            ]?.ruleType
                              ? "error"
                              : ""
                          }
                        >
                          <Controller
                            control={control}
                            name={`job.fileNameProcessing.processingRules.${index}.ruleType`}
                            render={({ field }) => (
                              <Select
                                style={{ width: "180%" }}
                                {...field}
                                showSearch
                                placeholder="Enter Type"
                                allowClear
                              >
                                <Option value="Trim">Trim</Option>
                                <Option value="TrimStart">Trim Start</Option>
                                <Option value="TrimEnd">Trim End</Option>
                                <Option value="FindAndReplace">
                                  Find And Replace
                                </Option>
                                <Option value="AppendAtStart">
                                  Append At Start
                                </Option>
                                <Option value="AppendAtEnd">
                                  Append At End
                                </Option>
                              </Select>
                            )}
                          />
                        </Form.Item>
                        {processingRuleType(index)}
                        <MinusCircleOutlined
                          onClick={() => processingRulesRemove(index)}
                        />
                      </Space>
                    </div>
                  </>
                );
              })}
              <Button
                block
                type="dashed"
                icon={<PlusOutlined />}
                onClick={() =>
                  processingRulesAppend({
                    ruleType: "",
                  })
                }
              >
                Add File Name Selection Segment
              </Button>
            </Form.Item>
          </Panel>
        </Collapse>
      </div>
    </>
  );
};

export default FileNameProcessingElement;
